// extracted by mini-css-extract-plugin
export default {"infoBox":"TF4QcAAJUX66ShuRuSJA"};